import PropTypes from 'prop-types';
import React from 'react';
import hoist from 'hoist-non-react-statics';
import getDisplayName from '../../utils/displayName';

export function withConditionalRender(WrappedComponent) {
    class ConditionallyRenderedComponent extends React.Component {
        static displayName = `ConditionallyRendered(${getDisplayName(WrappedComponent)})`;
        static propTypes = {
            render: PropTypes.bool,
        };

        render() {
            const { render, ...props } = this.props;

            return render ? <WrappedComponent {...props} /> : null;
        }
    }

    hoist(ConditionallyRenderedComponent, WrappedComponent);

    return ConditionallyRenderedComponent;
}
